import { PreferencesService, PreferencesServiceImpl } from "processes/Preferences";

function initPreferencesService(): PreferencesService {
  return new PreferencesServiceImpl();
}

export default initPreferencesService;
